'use client';

import React, { useState } from 'react';
import { c } from '../../../utils/tailwind-merge';
import { Rating, RatingButton } from '../Rating';
import { StarsV2Props } from './Stars.v2.types';

const MAX_DEFAULT = 5;
const WIDTH_DEFAULT = 16;
const HEIGHT_DEFAULT = 16;

export const StarsV2 = React.forwardRef<HTMLDivElement, StarsV2Props>(
  ({
    value,
    ariaLabel,
    max = MAX_DEFAULT,
    width = WIDTH_DEFAULT,
    height = HEIGHT_DEFAULT,
    variant = 'black',
    editable = false,
    className,
  }: StarsV2Props) => {
    const [rating, setRating] = useState(value);

    const computedAriaLabel =
      ariaLabel ?? `${editable ? rating : value} out of ${max} stars`;

    return (
      <div className={c('flex flex-col items-center gap-3', className)}>
        <Rating
          value={editable ? rating : value}
          readOnly={!editable}
          onValueChange={editable ? setRating : undefined}
        >
          {Array.from({ length: max }).map((_, i) => (
            <RatingButton
              variant={variant}
              width={width}
              height={height}
              // eslint-disable-next-line react/no-array-index-key
              key={`star-${i}`}
              ariaLabel={computedAriaLabel}
            />
          ))}
        </Rating>
      </div>
    );
  }
);

StarsV2.displayName = 'StarsV2';
